import React from 'react';
import { toast, Bounce, ToastOptions } from 'react-toastify';

export interface CustomToastOptions extends ToastOptions {
  message: string;
}

export function showCustomToast(message: string, options?: ToastOptions) {
  toast(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Bounce,
    style: {
      zIndex: '9999',
      backgroundColor: 'var(--modal)',
      color: 'var(--text)',
      border: '1px solid var(--secondary20)',
      borderRadius: '0.75rem',
      boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
      fontWeight: 500,
      ...options?.style,
    },
    ...options,
  });
}

export const CustomToast: React.FC<{ message: string }> = ({ message }) => (
  <div
    style={{
      zIndex: '9999',
      backgroundColor: 'var(--modal)',
      color: 'var(--text)',
      border: '1px solid var(--secondary20)',
      borderRadius: '0.75rem',
      boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
      fontWeight: 500,
      padding: '0.75rem 1rem',
    }}
  >
    {message}
  </div>
);
